import React from "react";

const DateField = React.forwardRef(({ label, name, error, ...props }, ref) => {
  // Fungsi untuk memunculkan date picker saat input diklik (harus user gesture)
  const handleClick = (e) => {
    if (e.target.showPicker) {
      e.target.showPicker();
    }
  };

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block mb-1 text-sm font-semibold text-green-800"
        >
          {label}
        </label>
      )}
      <input
        type="date"
        id={name}
        name={name}
        ref={ref}
        onClick={handleClick} // gunakan onClick, bukan onFocus
        {...props}
        className={`w-full px-3 py-2 text-sm transition border rounded-md focus:ring-2 ${
          error
            ? "border-red-500 focus:ring-red-300"
            : "border-green-300 focus:ring-green-400"
        }`}
      />
      {error && <p className="mt-1 text-xs text-red-500">{error.message}</p>}
    </div>
  );
});

export default DateField;
